<script>
import { onMounted, ref, toRef } from 'vue'
import { useStore } from '../../store'

export default {
  props: {
    desktop: {
      type: Object,
      required: false,
      default: ''
    },
    mobile: {
      type: Object,
      required: false,
      default: ''
    }
  },
  setup(props, { slots }) {
    const initialD  = toRef(props, 'desktop')
    const desktop   = ref(initialD.value)
    const initialM  = toRef(props, 'mobile')
    const mobile    = ref(initialM.value)
    const store     = useStore()
    const close     = () => {
      const now = new Date()
      store.drawers.popup = { show: false, expiry: now.getTime() + ( 60 * 60 * 1000 ) }
    }

    onMounted(() => {
      const now = new Date()
      if ( ! store.drawers.popup.expiry || now.getTime() > store.drawers.popup.expiry ) {
        store.drawers.popup.show = true
      }
    })

    return () => slots.default({
      active: store.drawers.popup.show,
      close
    })
  }
}
</script>